import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class StackLineGroupValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;

        let teamsLineGroups = {};
        Object.keys(stacking.groups).map((groupNumber) => {
            let group = stacking.groups[groupNumber];
            if (!group.team) {
                this.addError('You should set team.');
                return;
            }
            if (isEmpty(group.lineGroups)) {
                return;
            }

            if (!teamsLineGroups.hasOwnProperty(group.team)) {
                teamsLineGroups[group.team] = [];
            }
            teamsLineGroups[group.team] = [...teamsLineGroups[group.team], ...group.lineGroups];
        });

        if (!isEmpty(teamsLineGroups)) {
            Object.keys(teamsLineGroups).map((teamName) => {
                let uniqueLineGroups: any[] = [];
                teamsLineGroups[teamName].map((lineGroup) => {
                    if (!inArray(lineGroup, uniqueLineGroups)) {
                        uniqueLineGroups.push(lineGroup);
                    } else {
                        this.addError('Line groups should be unique for the same team.');
                    }
                });
            });
        }
    }
}

export default StackLineGroupValidator;
